import axios from 'axios';
import { urls } from '../config';
import { contextApp } from 'context';

export const useApiProducts = () => {
 const { auth } = contextApp();

 const ProductApi = axios.create({
  baseURL: urls.products(),
  headers: { 'x-access-token': auth?.token }
 });

 const getProduct = async ({ queryKey }) => {
  const [, code, params = {}] = queryKey;
  return (await ProductApi.get(`/${code}`, { params })).data;
 };

 const getProducts = async ({ queryKey }) => {
  const [, params = {}] = queryKey;
  return (await ProductApi.get('/', { params })).data;
 };

 const getRatings = async ({ queryKey }) => {
  const [, params = {}] = queryKey;
  return (await ProductApi.get('/reviews', { params })).data;
 };

 const getProductNames = async ({ queryKey }) => {
  const [, params = {}] = queryKey;
  return (await ProductApi.get('/names', { params })).data;
 };

 const createRating = async data => (await ProductApi.post('/rating', data)).data;

 const createProduct = async ({ data }) =>
  (await ProductApi.post('/', data, { headers: { 'Content-Type': 'multipart/form-data' } })).data;

 const addFavourite = async data => (await ProductApi.post('/favorite', data)).data;

 const removeFavourite = async id => (await ProductApi.delete('/favorite/' + id)).data;

 const updateProduct = async ({ code, data }) =>
  (await ProductApi.put('/' + code, data, { headers: { 'Content-Type': 'multipart/form-data' } })).data;

 const getContracts = async () => (await ProductApi.get('/')).data;

 return {
  getContracts,
  getProduct,
  getRatings,
  createRating,
  getProducts,
  getProductNames,
  createProduct,
  updateProduct,
  addFavourite,
  removeFavourite
 };
};

export default { useApiProducts };
